var React = require('react');

function WarningIconInline (overrides) {
const props = Object.assign({}, {"viewBox":"0 0 64 64","fill":"none"}, overrides);
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32","r":"32","fill":"#fff1d1","key":0}),React.createElement("path",{"d":"M24.47 40.504h15.06c1.54 0 2.5-1.67 1.73-3l-7.53-13.01a2 2 0 0 0-3.46 0l-7.53 13.01c-.77 1.33.19 3 1.73 3zm7.53-7c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z","fill":"#e3640d","key":1})]);
}

module.exports = WarningIconInline;

WarningIconInline.default = WarningIconInline;
